export const collator = Intl.Collator();
